export default {
  path: '/pushSet',
  name: 'pushSet',
  meta: { title: '推送设置' },
  redirect: '/',
  auth: 'igdsapi', // 暂时用这个权限 ，后面再改·
  component: () => import('@/views/pushSet/index.vue'),
  children: [
    {
      path: '/pushSet/unitSetting',
      name: 'unitSetting',
      meta: { title: '单位管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/unitSetting/list'),
    },
    {
      path: '/pushSet/StorageRoomSetting',
      name: 'StorageRoomSetting',
      meta: { title: '收纳库管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/StorageRoomSetting/list'),
    },
    {
      path: '/pushSet/ABarnSetting',
      name: 'ABarnSetting',
      meta: { title: '仓房管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/ABarnSetting/list'),
    },
    {
      path: '/pushSet/GranarySetting',
      name: 'GranarySetting',
      meta: { title: '廒间管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/GranarySetting/list'),
    },
    {
      path: '/pushSet/StorageLocationSetting',
      name: 'StorageLocationSetting',
      meta: { title: '货位管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/StorageLocationSetting/list'),
    },
    {
      path: '/pushSet/GrainStorageSetting',
      name: 'GrainStorageSetting',
      meta: { title: '粮食入库管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/GrainStorageSetting/list'),
    },
    {
      path: '/pushSet/GrainStorageAdd/:code?',
      name: 'GrainStorageAdd',
      meta: { title: '新增粮食入库', swiper: true },
      auth: 'createAcquisition',
      hide: true,
      component: () => import('@/views/pushSet/GrainStorageSetting/add'),
    },
    {
      path: '/pushSet/GrainStorageDetails/:id',
      name: 'GrainStorageDetails',
      meta: { title: '新增粮食入库编辑' },
      auth: 'createAcquisition',
      hide: true,
      component: () => import('@/views/pushSet/GrainStorageSetting/details'),
    },
    {
      path: '/pushSet/GrainInspectionSetting',
      name: 'GrainInspectionSetting',
      meta: { title: '来粮检验管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/GrainInspectionSetting/list'),
    },
    {
      path: '/pushSet/GrainAcquisitionSetting',
      name: 'GrainAcquisitionSetting',
      meta: { title: '粮食收购管理' },
      auth: 'listAccount',
      component: () => import('@/views/pushSet/GrainAcquisitionSetting/list'),
    }
  ],
}
